import * as React from 'react'

function SvgPs(props) {
	return (
		<svg viewBox="0 0 6 3" width="1em" height="1em" {...props}>
			<path fill="#007A3D" d="M0 0h6v3H0z" />
			<path fill="#FFF" d="M0 0h6v2H0z" />
			<path d="M0 0h6v1H0z" />
			<path fill="#CE1126" d="M0 0l2 1.5L0 3z" />
		</svg>
	)
}

export default SvgPs
